const PATH = "/api/v1";

const ENDPOINTS = {
  WEBAPP_HOSTELS: "/hostels/",
  WEBAPP_DESTINATIONS: "/destinations/",
  WEBAPP_RECENT_BLOGS: "/blogs/recent/",
};

export type WebAppEndpoints = keyof typeof ENDPOINTS;
export const WebAppCollection = { PATH, ENDPOINTS };
